import fetch from './communityFetch';

const appointmentConfig = params => fetch({ url: '/reserve_config', params, methold: 'post' });

const getAppointmentConfig = () => fetch({ url: '/reserve_config' });

const appointmentList = params => fetch({ url: '/reserve_list', params });

export default {
  appointmentConfig,
  appointmentList,
  getAppointmentConfig
};
